<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="font-semibold" [for]="resolvedId()">{{ label() }}</label>
  }

  <p-inputgroup>
    @if (icon()) {
      <p-inputgroup-addon>
        <ng-icon [name]="icon()" />
      </p-inputgroup-addon>
    }
    <p-password
      [id]="resolvedId()"
      [ngModel]="value()"
      (ngModelChange)="value.set($event)"
      [disabled]="edit()"
      [toggleMask]="true"
      [feedback]="false"
      [placeholder]="placeholder() ?? ''"
      class="w-full"
      [inputStyle]="{ width: '100%' }" />
  </p-inputgroup>
</div>
